import share from "./share.json";

export default {
  ...share,
};
